import React, { useEffect, useRef } from 'react';

function ProjectSlide(props) {

    const bodyText = props.text || "fasfa";
    const imgUrl = `/images/project-img-${props.name.toLowerCase().replaceAll(" ","-")}.jpg`;
    const bubbles = props.bubbles.split(",")

    const cardRef = useRef(null);
    const zoomPercentage = '1.06';
    const damper = 1;

    useEffect(() => {
        const $card = cardRef.current;
        let bounds;

        function rotateToMouse(e) {
            const mouseX = e.clientX;
            const mouseY = e.clientY;
            const leftX = mouseX - bounds.x;
            const topY = mouseY - bounds.y;
            const center = {
                x: leftX - bounds.width / 2,
                y: topY - bounds.height / 2
            };
            const distance = Math.sqrt(center.x ** 2 + center.y ** 2);

            // $card.style.transform = `
            //     scale3d(${zoomPercentage}, ${zoomPercentage}, ${zoomPercentage})
            // `;
                
            $card.style.transform = `
                scale3d(${zoomPercentage}, ${zoomPercentage}, ${zoomPercentage})
                rotate3d(
                    ${(center.y / damper) * -1},
                    ${center.x / damper},
                    0,
                    ${Math.log(distance) * 3}deg
                )
            `;

            const shadowOpacity = 0.25 - distance/600

            // $card.style.boxShadow = `${center.x/4}px ${center.y/4}px ${distance/20}px 0 rgba(250,226,166,${1 - distance/200})`
            $card.style.boxShadow = `0 7px 24px 10px rgba(201,139,7,0.14), ${center.x/4}px ${center.y/4}px ${5 + distance/20}px 0 rgba(69,61,40,${shadowOpacity > 0.05 ? shadowOpacity : 0.05})`

            const ydist = (bounds.height / 2 - topY) / (bounds.height / 2);
            const scaledYdist = (1 + (ydist * 0.2)) * -1;

            const brightMax = 1.05;
            const darkMax = 0.98;

            // $card.style.filter = `brightness(${scaledYdist > brightMax ? brightMax : scaledYdist < darkMax ? darkMax : scaledYdist})`;


            $card.querySelector('.glow').style.backgroundImage = `
                radial-gradient(
                    circle at
                    ${center.x * 2 + bounds.width / 2}px
                    ${center.y * 2 + bounds.height / 2}px,
                    #ffffff55,
                    #0000000f
                )
            `;

        }

        function handleMouseEnter() {
            bounds = $card.getBoundingClientRect();
            document.addEventListener('mousemove', rotateToMouse);
        }

        function handleMouseLeave() {
            document.removeEventListener('mousemove', rotateToMouse);
            $card.style.transform = '';
            $card.querySelector('.glow').style.backgroundImage = '';
        }

        $card.addEventListener('mouseenter', handleMouseEnter);
        $card.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            $card.removeEventListener('mouseenter', handleMouseEnter);
            $card.removeEventListener('mouseleave', handleMouseLeave);
            document.removeEventListener('mousemove', rotateToMouse);
        };
    }, []);

    return (
    <div className="card-holder">
        
        <div className="project-slide card" ref={cardRef} onClick={()=> {
            if(props.link)
                window.open(props.link, "_blank")

            if(props.apiUrl)
                props.loadModal(props.apiUrl)
        }}>
            <div className="project-image" style={{backgroundImage:`url('${imgUrl}')`}}></div>
            <b>{props.name}</b>
            <p>{bodyText}</p>
            <div className="project-bubbles">
                {bubbles.map(bubble=><span className="project-bubble">{bubble}</span>)}
            </div>
            <div className="glow"></div>
        </div>

        <div className="card-see-more-button">
            {props.link && <a href={props.link} target="_blank">See More</a>}
            {props.apiUrl && <button onClick={()=>props.loadModal(props.apiUrl)}>See More</button>}
        </div>

    </div>
    );
}

export default ProjectSlide;